import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-player-list',
  templateUrl: './player-list.component.html',
  styleUrls: ['./player-list.component.scss']
})
export class PlayerListComponent {

  public players:any = [];
  public _players:any = [];
  public from_date:any = null;
  public to_date:any = null;
  public search_player:any = null;
  public type:any = "register";
  public permission:any = {};
  public is_loading:boolean = false;
  public company_uuid:any = null;
  constructor(private http: HttpService) { 
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.todayDate();
    this.getPlayers();
    this.permission = this.http.getSelecetdCompanyDetail();
  }

  todayDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    this.from_date = `${year}-${month}-${day}`;
    this.to_date = `${year}-${month}-${day}`;
  }

  async getType(type:string) {
    this.type = type;
    await this.getPlayers();
  }

  async getPlayers() {
    this.is_loading = true;
    if(!this.permission.can_report) {
      this.to_date = this.from_date;
    }

    let y:any = await this.http.post("/admin/player/list", {from_date: this.from_date, to_date: this.to_date, type: this.type})
    this._players = y;
    this.players = y;

    this.is_loading = false;
  }

  async filterPlayer() {

    if(this.search_player && this.search_player.length > 0) {
      this.players = this._players.filter((player:any) => player.name.toLowerCase().includes(this.search_player.toLowerCase()) || player.code.toLowerCase().includes(this.search_player.toLowerCase()) || player.mobile.toLowerCase().includes(this.search_player.toLowerCase()));
    } else {
      this.players = this._players;
    }
  }

}
